export default {
    data() {
        return {
            form: {
                contentBlocks: this.getFormData("content_blocks", []),
            },
        };
    },
    methods: {
        defaultTableData: function () {
            return {
                id: null,
                type_id: null,
                heading_text: null,
                heading_type: null,
                anchor_id: null,
                anchor_text: null,
                document: null,
                document_type: null,
                document_id: null,
                bonus: null,
                bonus_id: null,
                image: null,
                image_id: null,
                language_id: null,
                headers: [],
                rows: [],
            };
        },
        addContentBlock: function () {
            this.form.contentBlocks = [
                ...this.form.contentBlocks,
                {
                    title: "",
                    allowed_countries: [],
                    restricted_countries: [],
                    sections: [
                        {
                            content: "",
                            bonuses: [],
                            alert_boxes: [],
                            image: null,
                            link: {},
                            table: this.defaultTableData(),
                            latest_articles_element: {},
                            ordered_list: {},
                            list_with_images: [],
                            comparison_elements: [],
                            list_with_background_image: [],
                            reference_list: {},
                            jump_navi_with_author_quote: null,
                            software_table_with_big_list: [],
                            license_table_with_big_list: [],
                            country_table_with_big_list: [],
                            payment_method_table_with_big_list: [],
                            payment_method_table_with_big_list_options: {
                                listAll: "1",
                                displayAll: null,
                                listOrder: null, // ['usage', 'alphabetical']
                                openDisplayLimit: null,
                                listLimit: null,
                                isPaymentCategoryPage: false,
                                excludeAssociatedPaymentMethod: false,
                                paymentMethodId: null,
                            },
                            side_by_side_text: {
                                right_text: null,
                                left_text: null,
                            },
                            content_table: {},
                            deposit_withdrawal_methods_and_currencies: false,
                            show_market_data: false,
                            show_additional_casinos: false,
                            list_of_available_games: false,
                            list_of_available_languages: false,
                            list_of_not_recommended_casinos: false,
                            list_of_out_of_business_casinos: false,
                        },
                    ],
                },
            ];
        },
        addContentSection: function (index) {
            this.form.contentBlocks[index].sections = [
                ...this.form.contentBlocks[index].sections,
                {
                    content: "",
                    bonuses: [],
                    alert_boxes: [],
                    image: null,
                    link: {},
                    table: this.defaultTableData(),
                    latest_articles_element: {},
                    ordered_list: {},
                    list_with_images: [],
                    comparison_elements: [],
                    list_with_background_image: [],
                    reference_list: {},
                    jump_navi_with_author_quote: null,
                    software_table_with_big_list: [],
                    license_table_with_big_list: [],
                    country_table_with_big_list: [],
                    payment_method_table_with_big_list: [],
                    payment_method_table_with_big_list_options: {
                        listAll: "1",
                        displayAll: null,
                        listOrder: null, // ['usage', 'alphabetical']
                        openDisplayLimit: null,
                        listLimit: null,
                        isPaymentCategoryPage: false,
                        excludeAssociatedPaymentMethod: false,
                        paymentMethodId: null,
                    },
                    side_by_side_text: {
                        right_text: null,
                        left_text: null,
                    },
                    content_table: {},
                    deposit_withdrawal_methods_and_currencies: false,
                    show_market_data: false,
                    show_additional_casinos: false,
                    list_of_available_games: false,
                    list_of_available_languages: false,
                    list_of_not_recommended_casinos: false,
                    list_of_out_of_business_casinos: false,
                },
            ];
        },
        deleteContentBlock: function (index) {
            // check for how to
            if (
                this.form.contentBlocks[index].sections.filter(
                    (contentSection) =>
                        contentSection.contentSectionUuid ===
                        this.contentSectionWithHowTo
                ).length
            ) {
                this.contentSectionWithHowTo = null;
            }

            // check for bonus list top
            if (
                this.form.contentBlocks[index].sections.filter(
                    (contentSection) =>
                        contentSection.contentSectionUuid ===
                        this.contentSectionWithBonusListTop
                ).length
            ) {
                this.contentSectionWithBonusListTop = null;
            }

            // check for bonus list bottom
            if (
                this.form.contentBlocks[index].sections.filter(
                    (contentSection) =>
                        contentSection.contentSectionUuid ===
                        this.contentSectionWithBonusListBottom
                ).length
            ) {
                this.contentSectionWithBonusListBottom = null;
            }

            // check for ranking
            this.form.contentBlocks[index].sections.forEach(
                (contentSection) => {
                    let index = this.contentSectionsWithRanking.indexOf(
                        contentSection.contentSectionUuid
                    );
                    if (index >= 0) {
                        this.contentSectionsWithRanking.splice(index, 1);
                    }
                }
            );

            this.form.contentBlocks.splice(index, 1);
        },
        deleteContentSection: function ({ contentBlockIndex, sectionIndex }) {
            this.form.contentBlocks[contentBlockIndex].sections.splice(
                sectionIndex,
                1
            );
            this.$forceUpdate();
        },
        loadContentBlocks: function (data) {
            if (data.action === "replace") {
                this.form.contentBlocks = data.contentBlocks;
            } else if (data.action === "append") {
                this.form.contentBlocks = [
                    ...this.form.contentBlocks,
                    ...data.contentBlocks,
                ];
            }
        },
    },
};
